module.exports = "/static/assets/85288751058f7704ffdb91f15d189260.svg";